export const calendarReducer = (state = { loading: false, events: [], schedule: [], calendarError: null }, action) => {
    switch (action.type) {
        case 'CALENDAR_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'EVENTS_SUCCESS':
            return {
                ...state,
                loading: false,
                events: action.payload
            }
        case 'SCHEDULE_SUCCESS':
            return {
                ...state,
                loading: false,
                schedule: action.payload
            }
        case 'CALENDAR_ERROR':
            return {
                ...state,
                loading: false,
                calendarError: action.payload
            }
        default:
            return state
    }
}
